<template>
  <div class="wrapper">
    <cart-head :headTitle="$t('confirmAnOrder')"></cart-head>
    <div class="bgc">
      <div class="shop-container bgw">
        <div class="order-box">
          <div class="box-title">
            <div class="tabs">
              <h3
                :class="[tabCurrent === index ? 'tab-active' : '', 'tab']"
                v-for="(item, index) in tabs"
                :key="index"
                @click="changeTab(index)"
                v-if="storeSwitch == 1"
              >
                {{ item }}
              </h3>
            </div>
            <h3 v-if="storeSwitch != 1">{{ $t("shippingAddress") }}</h3>
          </div>
          <div v-if="tabCurrent == 1">
            <div class="box-info adress">
              <div
                class="item"
                v-for="(item, index) in addressList"
                :key="index"
                :class="{ active: curAddressIndex == index}"
                @click="selectCurAddress(item, index)"
              >
                <div class="name">{{ item.name }}</div>
                <div class="tel">{{ item.mobile }}</div>
                <div class="tel">{{ item.idcard_no }}</div>
                <div class="address">
                  {{ item.area_name }} {{ item.address }}
                </div>
                <div>
                  <span class="change" @click="modifyAddress(item)">{{
                    $t("edit")
                  }}</span>
                  <span
                    class="default"
                    @click="setDefault(item)"
                    v-show="item.is_def != 1"
                    >Set as My Address</span
                  >
                </div>
                <div class="default-icon" v-show="item.is_def == 1">
                  <img class="def-img" src="~@/assets/images/add-def.png" alt="">
                  <!-- <i class="icon iconfont icondefault"></i> -->
                </div>
              </div>
              <div class="add-adress item" @click="addAddressFunc">
                <i class="icon iconfont iconadd"></i>
                <!-- 添加收货地址 -->
                 <span style="margin:0 4px">{{ $t("add") }}</span>   {{ $t("shippingAddress") }}
              </div>
            </div>
          </div>
          <div v-if="tabCurrent == 0">
            <div>
              <div>
                <div class="delivery-item">
                  <label for="">{{ $t("name") }}：</label>
                  <input
                    type="text"
                    :placeholder="$t('pleaseEnterTheNameOfConsignee')"
                    v-model="store_pick.name"
                  />
                </div>
                <div class="delivery-item">
                  <label for="">{{ $t("mobile") }}：</label>
                  <input
                    type="text"
                    :placeholder="$t('pleaseEnterTheNameOfMobile')"
                    v-model="store_pick.mobile"
                    minlength="7"
                    maxlength="11"
                  />
                </div>
              </div>
              <div class="box-info adress">
                <div class="item active">
                  <div class="name">{{ store.name }}</div>
                  <div class="tel">{{ store.mobile }}</div>
                  <div class="tel">{{ store.idcard_no }}</div>
                  <div class="address">{{ store.address }}</div>
                  <div>
                    <span class="change" @click="addStoreFunc">{{
                      $t("changeStore")
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="order-box">
          <div class="box-title">
            <h3>{{ $t("goodsList") }}</h3>
          </div>
          <div class="box-info">
            <div class="cart-list-wrap">
              <div class="item-row item-head">
                <div class="cart-img">&nbsp;</div>
                <div class="cart-name">{{ $t("goodsInfo") }}</div>
                <div class="cart-info"></div>
                <div class="cart-price">Unit</div>
                <div class="cart-num">{{ $t("nums") }}</div>
                <div class="cart-total">{{ $t("subtotal") }}</div>
              </div>

              <div
                class="item-row"
                v-for="item in cartList"
                :key="item.id"
                v-if="item.is_select == true"
              >
                <div class="cart-img">
                  <img :src="item.products.image_path" alt />
                </div>
                <div class="cart-name">{{ item.products.name }}</div>
                <div class="cart-info">
                  <template v-if="item.products.spes_desc">
                    <div
                      v-for="(spe, i) in item.products.spes_desc.split(',')"
                      :key="i"
                      style="margin-bottom: 10px"
                    >
                      {{ spe }}
                    </div>
                  </template>
                </div>
                <div class="cart-price">
                  {{ $t("currencySymbol") }}{{ item.products.price }}
                </div>
                <div class="cart-num">{{ item.nums }}</div>
                <div class="cart-total">
                  {{ $t("currencySymbol") }}{{ item.products.amount }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="order-box">
          <div class="box-title">
            <h3>配送方式</h3>
          </div>
          <div class="box-info ct">包邮</div>
        </div>-->
        <!-- 发票 -->
        <!-- <div class="order-box">
          <div class="box-title">
            <h3>{{ $t("invoice", { text: "" }) }}</h3>
          </div>
          <div class="box-info invoice ct">
            <template v-if="invoice.type == 1">
              <span>{{ $t("noInvoice") }}</span>
            </template>
            <template v-else-if="invoice.type == 2">
              <span>{{ $t("electronicInvoice") }}</span>
              <span>{{ invoice.name }}</span>
              <span>{{ $t("goodsDetail") }}</span>
            </template>
            <template v-else>
              <span>{{ $t("electronicInvoice") }}</span>
              <span>{{ invoice.name }}</span>
              <span>{{ $t("goodsDetail") }}</span>
            </template>

            <span class="modify" @click="dialogInvoiceVisible = true"
              >{{ $t("edit") }}></span
            >
          </div>
        </div> -->
        <div class="order-box">
          <div class="box-title">
            <h3>Notes</h3>
          </div>
          <div class="box-info">
            <el-input
              type="textarea"
              :rows="4"
              placeholder="leave the message to us (max 50 words)."
              v-model="memo"
            >
            </el-input>
          </div>
        </div>

              <!-- 配送方式说明 -->
            <!-- 新疆、西藏地区，邮费自理，一律德邦到付（如有疑问请咨询在线客服） -->


        <!-- <div class="order-box">
          <div class="box-title">
            <h3>
              {{ $t("distributionModeTips") }}
            </h3>
          </div>
          <div class="box-info" style="color: #e7442f">
            {{ $t("distributionModeTipsDesc") }}
          </div>
        </div> -->

        <div class="order-box foot" style="overflow: hidden">
          <!-- <div class="l"> -->
          <div style="float: left">
            <div class="box-title">
              <h3>Discount Coupon</h3>
            </div>
            <div class="box-info">
              <div>
                <div class="conpon-tabs">
                   <span
                    :class="useCouponType == 1 ? 'active' : ''"
                    @click="useCouponType = 1"
                    >{{ $t("CouponCodeExchange") }}</span
                  >

                  <!-- <span
                    :class="useCouponType == 0 ? 'active' : ''"
                    @click="useCouponType = 0"
                    >{{ $t("coupon") }}</span
                  > -->
                 
                </div>
                <div class="tab-content" v-show="useCouponType == 0">
                  <div>
                    <template v-if="userCoupons.length == 0">
                      <span>{{ $t("noCoupon") }}</span>
                    </template>
                    <template v-else-if="userCoupons.length > 0">
                      <div class="coupon-list" style="padding: 20px 2px">
                        <div
                          class="coupon-wrap"
                          v-for="(item, index) in userCoupons"
                          :key="index"
                          @click="selectCoupon(item, index)"
                          :class="{
                            disabled: item.disabled,
                            checked: item.checked,
                          }"
                        >
                          <div class="content">
                            <div class="price">
                              <span class="num">{{ item.name }}</span>
                            </div>
                            <div class="desc">
                              {{ item.expression1 }}&nbsp;&nbsp;{{
                                item.expression2
                              }}
                            </div>
                            <div class="time">
                              {{ item.stime }}&nbsp;--&nbsp;{{ item.etime }}
                            </div>
                          </div>
                          <div class="status">
                            <template v-if="item.is_used == 2">
                              <i class="icon iconfont iconused"></i>
                            </template>
                            <template v-else-if="item.is_expire == 2">
                              <i class="icon iconfont iconnouse"></i>
                            </template>
                          </div>
                          <i
                            class="icon iconfont iconmiaojiesellerselected"
                            v-if="item.checked"
                          ></i>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
                <div class="tab-content" v-show="useCouponType == 1">
                  <div class="exchange">
                    <span>{{ $t("EnterCouponNumber") }}</span>
                    <input type="text" v-model="inputCouponCode" />
                    <a href="javascript:;" @click="receiveCoupon">{{
                      $t("use")
                    }}</a>
                  </div>
                  <div class="coupon-list" style="padding: 20px 2px">
                    <div
                      class="coupon-wrap"
                      v-for="(item, index) in inputCouArr"
                      :key="index"
                      @click="removeCouponCode(item, index)"
                      :class="{ checked: item.checked }"
                    >
                      <div class="content">
                        <div class="price">
                          <span class="num">{{ item.name }}</span>
                        </div>
                        <div class="desc">{{ item.code }}</div>
                      </div>
                      <i
                        class="icon iconfont iconmiaojiesellerselected"
                        v-if="item.checked"
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="r">
            <div class="total-box">
              <div class="item">
                <span class="title">{{ $t("goodsNums") }}：</span>
                <span class="num">{{ productNums }} {{ $t("piece") }}</span>
              </div>
              <div class="item">
                <span class="title">{{$t('productPrice')}}：</span>
                <span class="num">{{ cartData.goods_amount }}</span>
              </div>
              <div class="item" v-if="cartData.goods_pmt_old > 0">
                <span class="title">{{ $t("goodsDiscounts") }}：</span>
                <span class="num">-{{ cartData.goods_pmt }}</span>
              </div>
              <div class="item" v-if="cartData.order_pmt_old > 0">
                <span class="title">{{ $t("orderDiscounts") }}：</span>
                <span class="num">-{{ cartData.order_pmt }}</span>
              </div>
              <!-- <div class="item">
                <span class="title">优惠券抵扣：</span>
                <span class="num">-0</span>
              </div>-->
              <div class="item">
                <span class="title">{{ $t("freight") }}：</span>
                <span class="num">{{ cartData.cost_freight }}</span>
              </div>
              <div class="item total">
                <!-- 总价格 -->
                <span class="title"
                  >{{ $t("total", { text: "" }) }}{{ $t("price") }}：</span
                >
                <span class="num">
                  <i class="total-num">{{ cartData.amount }}</i>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="foot-bar">
          <el-button class="btn" :loading="btnLoading" @click="toPay">{{
            $t("toPay")
          }}</el-button>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('invoiceInformation')"
      :visible.sync="dialogInvoiceVisible"
      class="invoice"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <div class="adress-form">
          <div class="invoice-section">
            <span class="tit">{{ $t("invoiceType") }}：</span>
            <div class="form-section invoice-tabs">
              <div
                class="invoice-type self"
                :class="{ active: invoiceType == 0 }"
                @click="invoiceType = 0"
              >
                {{ $t("personage") }}/{{ $t("publicInstitution") }}
              </div>
              <div
                class="invoice-type"
                @click="invoiceType = 1"
                :class="{ active: invoiceType == 1 }"
              >
                {{ $t("enterprise") }}
              </div>
            </div>
          </div>
          <div class="invoice-section">
            <span class="tit">{{ $t("invoiceTitle") }}：</span>
            <div class="invoice-input-wrap">
              <el-form-item prop="identify">
                <el-input
                  v-model="ruleForm.title"
                  :placeholder="$t('plaseEnterInvoiceTitle')"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="invoice-section" v-show="invoiceType == 1">
            <span class="tit">{{ $t("taxpayer'sRegistrationNumber") }}：</span>
            <div class="invoice-input-wrap">
              <el-form-item prop="identify">
                <el-input
                  v-model="ruleForm.identify"
                  :placeholder="$t('plaseEnterTaxpayer\'sRegistrationNumber')"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <!-- <div class="invoice-section">
            <span class="tit">收票邮箱：</span>
            <div class="invoice-input-wrap">
              <el-form-item prop="email">
                <el-input v-model="ruleForm.email" placeholder="请输入收票人邮箱"></el-input>
              </el-form-item>
            </div>
          </div> -->
          <div class="invoice-section">
            <span class="tit">{{ $t("invoiceContent") }}：</span>
            <div class="invoice-input-wrap">
              <span>{{ $t("goodsDetail") }}</span>
            </div>
          </div>
        </div>
        <div class="form-foot">
          <div class="foot-btn save" @click="submitForm('ruleForm')">
            {{ $t("save") }}
          </div>
          <div class="foot-btn cancel" @click="notNeedInvoice">
            {{ $t("noInvoice") }}
          </div>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="$t('storeList')"
      :visible.sync="dialogStoreVisible"
      class="store"
    >
      <div class="store-form">
        <div class="search">
          <input
            type="text"
            :placeholder="$t('pleseEnterStoreName')"
            class="search-input"
            v-model="key"
          />
          <div class="search-icon-wrap">
            <div class="search-icon">
              <i class="el-icon-search" @click="storeSearch"></i>
            </div>
          </div>
        </div>
        <div v-if="storeList.length">
          <div
            class="store-list"
            v-for="(store, index) in storeList"
            :key="index"
            @click="
              selectStore(
                store.id,
                store.store_name,
                store.mobile,
                store.all_address
              )
            "
          >
            <div class="store-l">
              <img
                src="../assets/icon/homepage.png"
                alt=""
                class="store-icon"
              />
            </div>
            <div class="store-item">
              <div class="item store-name">
                {{ $t("storeName") }}：{{ store.store_name }}
              </div>
              <div class="item store-mobile">
                {{ $t("storeMobile") }}：{{ store.mobile }}
              </div>
              <div class="item store-mobile">
                {{ $t("storeAddress") }}：{{ store.all_address }}
              </div>
            </div>
          </div>
        </div>

        <div class="nodata" v-else>
          {{ $t("noStoresWereFound") }}
        </div>
      </div>
    </el-dialog>
    <SelectAddress
      :dialogAdressVisible="dialogAddressShow"
      @hideDialog="hideDialog"
      :data="modifyData"
      :type="addressDialogType"
    ></SelectAddress>
  </div>
</template>

<script>
import CartHead from "@/components/cart/CartHead.vue";
import SelectAddress from "@/components/address/index";
import { mapActions } from "vuex";
import { formatMoney } from "@/utils";
// import { log } from 'util';
import { inputCheckPhone } from "@/utils/index";
export default {
  name: "Order",
  components: { CartHead, SelectAddress },
  props: {},
  data() {
    return {
      cartData: {}, // 购物车商品详情
      params: {
        ids: 0, // 传递过来的购物车id
        area_id: 0, // 收货地址id
        coupon_code: "", // 优惠券码列表(string)多张逗号分隔
        point: 0, // 抵扣X币额
      }, // 监听params参数信息 以重新请求接口
      invoice: {
        type: "1", // 类型 1不开发票 2个人发票 3公司发票
        name: "不开发票", // 发票抬头
        code: "", // 发票税号
      },
      ruleForm: {
        title: "",
        email: "",
      },
      //地址管理
      userShip: {}, // 用户当前选择的收货地址
      receiptType: 1, // 订单类型 1是发货订单 2是门店自提订单
      curAddressIndex: -1,
      modifyData: null,
      dialogAddressShow: false,
      dialogInvoiceVisible: false,
      invoiceType: 0, //发票类型 0个人 1企业
      addressDialogType: 0, // 新增0 修改1
      cartList: [], //商品列表,
      promotions: [], // 促销信息
      userCoupons: [], // 用户的可用优惠券列表
      usedCoupons: {}, // 已经选择使用的优惠券
      inputCouponCode: "", // 输入的优惠券码
      optCoupon: "", //当前选择使用的优惠券
      inputCouArr: [], //输入的优惠券码列表
      useCouponType: 1, //优惠券tab切换
      btnLoading: false, // 提交按钮禁用
      memo: "",
      tabs: [this.$t("takeTheir"), this.$t("expressage")],
      tabCurrent: 1,
      store: {
        id: 0,
        name: "",
        mobile: "",
        address: "",
      },
      store_pick: {
        name: "",
        mobile: "",
      },
      storeList: [],
      key: "",
      dialogStoreVisible: false,
    };
  },
  watch: {
    params: {
      handler() {
        this.getCartList();
      },
      deep: true,
    },
  },
  computed: {
    addressList() {
      return this.$store.state.addressList;
    },
    rules() {
      let formRules = {
        title: [
          {
            required: true,
            message: this.$t("plaseEnterInvoiceTitle"),
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: this.$t("plaseEnterEmail"),
            trigger: "blur",
          },
          {
            type: "email",
            message: this.$t("pleaseEnterTheCorrectEmail"),
            trigger: ["blur", "change"],
          },
        ],
      };
      if (this.invoiceType) {
        formRules["identify"] = [
          {
            required: true,
            message: this.$t("plaseEnterTaxpayer'sRegistrationNumber"),
            trigger: "blur",
          },
        ];
      }
      return formRules;
    },
    //商品总数量
    // 计算购物车商品数量
    productNums() {
      let nums = 0;
      for (let i in this.cartData.list) {
        if (this.cartData.list[i].is_select) {
          nums += parseFloat(this.cartData.list[i].nums);
        }
      }
      return nums;
    },
    // 判断店铺开关
    storeSwitch() {
      return this.$store.state.config.store_switch || 2;
    },
  },
  methods: {
    ...mapActions(["getUserShipListAction"]),
    //选择收货地址
    selectCurAddress(item, index) {
      this.curAddressIndex = index;
      this.params.area_id = item.area_id;
      this.userShip = item;
    },
    //不开发票
    notNeedInvoice() {
      this.invoice = {
        type: "1",
        name: this.$t("noInvoice"),
        code: "",
      };
      this.dialogInvoiceVisible = false;
    },
    hideDialog() {
      this.dialogAddressShow = false;

      this.userDefaultShip();
      this.userShipList();

      this.getUserCounpons();
      //获取默认门店信息
      this.getDefaultStore();
      // 获取门店列表
      this.getStoreList();

      this.getCartList()
    },
    addAddressFunc() {
      this.dialogAddressShow = true;
      this.modifyData = {};
    },
    modifyAddress(item) {
      this.modifyData = item;
      this.dialogAddressShow = true;
    },
    setDefault(item) {
      this.$api.setDefShip({ id: item.id }).then((res) => {
        if (res.status) {
          this.$msg(this.$t("setSuccess"));
          this.getUserShipListAction(); //添加成功获取最新列表
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.invoice = {
            type: this.invoiceType ? "3" : "2",
            name: this.ruleForm.title,
            code: this.invoiceType ? this.ruleForm.identify : "",
            // email:this.ruleForm.email     //邮箱暂无
          };
          this.dialogInvoiceVisible = false;
        } else {
          return false;
        }
      });
    },
    toPay() {
      this.btnLoading = true;
      let data = {
        source: 1,
        cart_ids: this.params.ids,
        // coupon_code: this.params.coupon_code,
        point: this.params.point,
        receipt_type: this.receiptType,
      };
      if (this.params.coupon_code != "-1") {
        data.coupon_code = this.params.coupon_code;
      } else {
        data.coupon_code = "";
      }
      if (this.params.coupon_code == "") {
        this.userCoupons.forEach((item) => {
          if (item.checked) {
            this.params.coupon_code = item.coupon_code;
          }
        });
        data.coupon_code = this.params.coupon_code;
      }

      let delivery = {};

      // 判断是快递配送还是门店自提
      if (this.receiptType == 1) {
        if (!this.userShip.id || !this.params.area_id) {
          this.$msg(this.$t("pleaseEntershippingAddress"), "warning");
          this.btnLoading = false;
          return false;
        }
        // 快递配送
        delivery = {
          uship_id: this.userShip.id,
          area_id: this.params.area_id,
        };
      }
      if (this.receiptType == 2) {
        if (!this.store.id) {
          this.$msg(this.$t("pleaseSelectPick-upStore"), "warning");
          this.btnLoading = false;
          return false;
        }
        if (!this.store_pick.name) {
          this.$msg(this.$t("pleaseEnterTheNameOfTheCarrier"), "warning");
          this.btnLoading = false;
          return false;
        }
        if (!this.store_pick.mobile) {
          this.$msg(this.$t("pleaseEnterTheCarrierNumber"), "warning");
          this.btnLoading = false;
          return false;
        }
        if (!inputCheckPhone(this.store_pick.mobile)) {
          this.$msg(this.$t("mobileError"), "warning");
          this.btnLoading = false;
          return false;
        }
        // 门店自提
        delivery = {
          store_id: this.store.id,
          lading_name: this.store_pick.name,
          lading_mobile: this.store_pick.mobile,
        };
      }
      // 发票信息
      data["tax_type"] = this.invoice.type;
      data["tax_name"] = this.invoice.name;
      data["tax_code"] = this.invoice.code;
      data.memo = this.memo;

      data = Object.assign(data, delivery);
      this.$api
        .createOrder(data)
        .then((res) => {
          if (res.status) {
            this.btnLoading = false;

            this.googleAd(res.data.order_id)
            this.facebookAddCheckOut(res.data.order_id)
            this.$router.replace({
              name: "cashier",
              params: {
                order_id: res.data.order_id,
              },
            });
          } else {
            this.$msg(res.msg, "error");
            this.btnLoading = false;
          }
        })
        .catch((err) => {
          console.log("err", err);
          this.btnLoading = false;
        });
    },
    googleAd(orderId) {
      return ;
      let items = []
      let transactionProducts = []
      for(let i of this.cartList) {
        items.push({'id': i.products.id, 'google_business_vertical': 'retail'})

        transactionProducts.push(
          {'sku': i.products.spes_desc, 'name': i.products.name, 'price': i.products.price, 'quantity': i.nums}
        )
      }
      // Universal Analytics 电子商务
      dataLayer.push({
          'transactionId': orderId,  // 订单号？
          'transactionTotal': this.cartData.amount, // 商品总价格？
          'transactionProducts': transactionProducts,
		  'currency': 'USD'
      });


      // Google Ads 动态再营销
      dataLayer.push({
        'event': 'purchase', // 购买操作
        'value': this.cartData.amount, // 这个 值哪里来的
        'items': items,
		'transaction_id':this.orderInfo.order_id,
		'currency': 'USD'
      })

      
    },
	//facebook添加购物车去结算
	facebookAddCheckOut(orderId){
		let userInfo = this.$storage.get('userInfo');
		let items = []
		let content_ids = []
		for(let i of this.cartList) {
		  items.push({'id': i.products.id, 'quantity': i.nums})
		  content_ids.push(
		    i.products.id
		  )
		}
		let initiateCheckout = {
			content_category:orderId,
			content_ids:content_ids,
			content_type:'product_group',
			contents:items,
			currency:'USD',
			num_items: this.productNums,
			value:userInfo.id,
		}
		window.fbq('track', 'InitiateCheckout',initiateCheckout);
	},
    // 获取购物车商品详情
    getCartList() {
      // let data = this.params
      let data = JSON.parse(JSON.stringify(this.params));
      data["receipt_type"] = this.receiptType; // 区分订单类型  1快递订单 2门店自提订单
      //如果都取消使用就不传coupon_code
      if (data.coupon_code == "-1") {
        delete data.coupon_code;
      }
      this.$api.cartList(data).then((res) => {
        if (res.status) {
          let data = res.data;

          // 所有价格转换
          data.amount = formatMoney(data.amount);
          data.goods_amount = formatMoney(data.goods_amount);
          data.goods_pmt_old = data.goods_pmt;
          data.goods_pmt = formatMoney(data.goods_pmt);
          data.coupon_pmt = formatMoney(data.coupon_pmt);
          data.order_pmt_old = data.order_pmt;
          data.order_pmt = formatMoney(data.order_pmt);
          data.point_money = formatMoney(data.point_money);
          data.cost_freight = formatMoney(data.cost_freight);

          //购物车详情
          this.cartData = data;
          //商品列表
          this.cartList = data.list;
          // 优惠信息
          this.promotions = data.promotion_list;
          // 使用的优惠券信息
          this.usedCoupons = data.coupon;

          // 更改优惠券状态
          this.userCoupons.forEach((item) => {
            if (item.checked1) {
              item.checked = item.checked1;
            }
          });

          // 展示优惠券码
          if (this.inputCouponCode) {
            for (let key in this.usedCoupons) {
              if (key == this.inputCouponCode) {
                let item = {};
                item.code = key;
                item.name = this.usedCoupons[key];
                item.checked = true;
                this.inputCouArr.push(item);
              }
            }
          }
          // 默认选中一张优惠券
          if (this.params.coupon_code == "") {
            if (this.usedCoupons.length != 0) {
              let usedCouponsList = [];
              for (let key in this.usedCoupons) {
                let item = {};
                item.code = key;
                item.name = this.usedCoupons[key];
                usedCouponsList.push(item);
              }
              this.userCoupons.forEach((item) => {
                if (item.coupon_code == usedCouponsList[0].code) {
                  item.checked = true;
                  item.checked1 = true;
                }
              });
            }
          }
          // 清空输入的优惠券码
          this.inputCouponCode = "";
          //清空暂存的优惠券(当前选择的优惠券)
          this.optCoupon = "";
          // 判断是否开启X币抵扣并且没有勾选X币使用
          // if (this.isOpenPoint === 1 && !this.isUsePoint) {
          //   let money = {
          //     order_money: data.amount
          //   };
          //   this.$api.usablePoint(money, res => {
          //     if (res.status) {
          //       this.userPointNums = res.data; // 用户总X币
          //       this.canUsePoint = res.available_point; // 可以使用的X币
          //       this.pointMoney = res.point_rmb; // X币抵扣的总金额
          //     }
          //   });
          // }
        } else {
          // 优惠券排他
          if (res.data == "15030") {
            // 分两种情况
            // 第一种 当前选择的优惠券权重最大
            var _this = this;
            if (
              this.optCoupon == res.exclusive_code ||
              this.inputCouponCode == res.exclusive_code
            ) {
              // 排斥的优惠券(权重小的)
              let exclusive_arr = res.exclusive_arr;
              let nameArr = [];
              exclusive_arr.forEach((item) => {
                item.name = "'" + item.name + "'";
                nameArr.push(item.name);
              });
              let nameList = nameArr.join(",");
              let msg = this.$t("collide", { nameList });
              this.$confirm(this.$t("tips"), msg, {
                confirmButtonText: this.$t("confirm"),
                cancelButtonText: this.$t("cancel"),
                type: "info",
              })
                .then(() => {
                  // 从使用中的优惠券去掉排他的优惠券
                  let exclusive_arr = res.exclusive_arr;
                  let paramsCodes = _this.params.coupon_code.split(",");
                  exclusive_arr.forEach((item1) => {
                    _this.userCoupons.forEach((item2) => {
                      if (item1.code == item2.coupon_code) {
                        item2.checked1 = false;
                        item2.checked = false;
                      } else if (res.exclusive_code == item2.coupon_code) {
                        item2.checked1 = true;
                        item2.checked = true;
                      }
                    });
                    // 从手输的列表中去掉排他的优惠券
                    _this.inputCouArr.forEach((item3, index1) => {
                      if (item1.code == item3.code) {
                        _this.inputCouArr.splice(index1, 1);
                      }
                    });
                    // 从params中去掉排他的优惠券
                    paramsCodes.forEach((item4, index2) => {
                      if (item1.code == item4) {
                        paramsCodes.splice(index2, 1);
                      }
                    });
                    _this.params.coupon_code = paramsCodes.join();
                  });
                })
                .catch(() => {
                  // 从优惠券列表中去掉当前选择的优惠券
                  _this.userCoupons.forEach((item5) => {
                    if (
                      item5.coupon_code == _this.optCoupon ||
                      item5.coupon_code == _this.inputCouponCode
                    ) {
                      item5.checked1 = false;
                      item5.checked = false;
                    }
                  });
                  // 从手输的列表中去掉当前选择的优惠券
                  _this.inputCouArr.forEach((item6, index1) => {
                    if (
                      item6.code == _this.optCoupon ||
                      item6.code == _this.inputCouponCode
                    ) {
                      _this.inputCouArr.splice(index1, 1);
                    }
                  });
                  // 从params中去掉当前选择的优惠券
                  let paramsCodes = _this.params.coupon_code.split(",");
                  paramsCodes.forEach((item7, index2) => {
                    if (
                      item7 == _this.optCoupon ||
                      item7 == _this.inputCouponCode
                    ) {
                      paramsCodes.splice(index2, 1);
                    }
                  });
                  _this.params.coupon_code = paramsCodes.join();
                });
            } else {
              // 第二种 已经选择的优惠券中权重大于当前选择的优惠券
              let msg = this.$t("collide", { nameList: res.exclusive_name });
              // let msg = '此优惠券与‘' + res.exclusive_name + '’冲突，确定使用吗？'

              this.$confirm(this.$t("tips"), msg, {
                confirmButtonText: this.$t("confirm"),
                cancelButtonText: this.$t("cancel"),
                type: "info",
              })
                .then(() => {
                  // 从使用中的优惠券去掉权重最大优惠券,添加当前优惠券
                  _this.userCoupons.forEach((item) => {
                    if (_this.optCoupon == item.coupon_code) {
                      item.checked1 = true;
                    } else if (res.exclusive_code == item.coupon_code) {
                      item.checked1 = false;
                      item.checked = false;
                    }
                  });
                  // console.log(_this.userCoupons);
                  // 从手输的列表中去掉排他的优惠券
                  _this.inputCouArr.forEach((item, index) => {
                    if (item.code == res.exclusive_code) {
                      _this.inputCouArr.splice(index, 1);
                    }
                  });
                  // // 从params中去掉权重最大优惠券,添加当前优惠券
                  let paramsCodes = _this.params.coupon_code.split(",");
                  paramsCodes.forEach((item, index) => {
                    if (res.exclusive_code == item) {
                      paramsCodes.splice(index, 1);
                    }
                  });
                  _this.params.coupon_code = paramsCodes.join();
                })
                .catch(() => {
                  // 从优惠券列表中去掉当前选择的优惠券
                  _this.userCoupons.forEach((item5) => {
                    if (
                      item5.coupon_code == _this.optCoupon ||
                      item5.coupon_code == _this.inputCouponCode
                    ) {
                      item5.checked1 = false;
                      item5.checked = false;
                    }
                  });
                  // 从手输的列表中去掉当前选择的优惠券
                  _this.inputCouArr.forEach((item6, index1) => {
                    if (
                      item6.code == _this.optCoupon ||
                      item6.code == _this.inputCouponCode
                    ) {
                      _this.inputCouArr.splice(index1, 1);
                    }
                  });
                  // 从params中去掉当前选择的优惠券
                  let paramsCodes = _this.params.coupon_code.split(",");
                  paramsCodes.forEach((item7, index2) => {
                    if (
                      item7 == _this.optCoupon ||
                      item7 == _this.inputCouponCode
                    ) {
                      paramsCodes.splice(index2, 1);
                    }
                  });
                  _this.params.coupon_code = paramsCodes.join();
                });
            }
          } else {
            this.$msg(res.msg, "error");
            // 当前是手输的优惠券时
            if (this.useCouponType == 1) {
              this.delCouponCode(this.inputCouponCode, this.useCouponType);
            } else {
              // 当前时优惠券列表时
              if (this.optCoupon) {
                this.userCoupons.forEach((item) => {
                  if (item.coupon_code === this.optCoupon) {
                    item["checked1"] = false;
                  }
                });
              }
              this.delCouponCode(this.optCoupon, this.useCouponType);
            }
          }
        }
      });
    },
    // 获取用户的默认收货地址
    userDefaultShip() {
      this.$api.userDefaultShip({}).then((res) => {
        if (res.status && Object.keys(res.data).length) {
          this.userShip = res.data;
          this.params.area_id = res.data.area_id;
        }
      });
    },

    // 获取收货地址列表
    userShipList() {
      this.getUserShipListAction();
    },

    // 获取用户的可用优惠券信息
    getUserCounpons() {
      let data = {
        display: "no_used",
      };
      this.$api.userCoupon(data).then((res) => {
        if (res.status) {
          let _list = res.data.list;
          let nowTime = Math.round(new Date().getTime() / 1000).toString();
          // _list.forEach(item => {
          //   this.$set(item, "checked", false);
          //   // 判断优惠券是否有效(开始时间)
          //   this.$set(
          //     item,
          //     "disabled",
          //     item.start_time > nowTime ? true : false
          //   );
          //   this.$set(item, "cla", item.disabled ? "cci-l bg-c" : "cci-l"); // 绑定相应的class样式
          // });
          _list.forEach((item) => {
            item["checked"] = false;
            item["disabled"] = item.start_time > nowTime ? true : false;
          });
          this.userCoupons = _list;
          // console.log('use', this.userCoupons)
        }
      });
    },
    //选择优惠券
    selectCoupon(item, index) {
      // if (item["disabled"]) {
      //   return alert("不可与已勾选券叠加使用");
      // }
      // 更改使用/取消状态
      this.userCoupons[index].checked1 = !this.userCoupons[index].checked;
      // 暂存当次选中使用的优惠券key
      this.optCoupon = this.userCoupons[index].coupon_code;
      let arr = [];
      this.userCoupons.forEach((item) => {
        if (item.checked1) {
          arr.push(item.coupon_code);
        }
      });

      let coupon_code = this.params.coupon_code;
      // 选中优惠券
      if (this.userCoupons[index].checked1) {
        if (coupon_code && coupon_code != "-1") {
          // 正在使用的优惠
          coupon_code += "," + this.optCoupon;
        } else {
          coupon_code = arr.join();
        }
        this.params.coupon_code = coupon_code;
      } else {
        // 取消使用
        let paramsCodes = this.params.coupon_code.split(",");
        // console.log(paramsCodes);
        let usedIndex = paramsCodes.indexOf(
          this.userCoupons[index].coupon_code
        );
        if (usedIndex !== -1) {
          paramsCodes.splice(usedIndex, 1);
          this.params.coupon_code = paramsCodes.join();
        }
        this.userCoupons[index].checked = false;

        // 如果都取消使用就不传coupon_code
        this.userCoupons.forEach((item) => {
          if (
            item.checked == false &&
            !this.inputCouArr.length &&
            (paramsCodes.length == 0 || JSON.stringify(paramsCodes) == '[""]')
          ) {
            this.params.coupon_code = "-1";
          }
        });
      }
    },
    //兑换优惠券
    receiveCoupon() {
      if (!this.inputCouponCode) {
        this.$msg(this.$t("EnterCouponNumber"), "warning");
      } else {
        // 判断是否有使用的优惠券
        let paramsCodes = this.params.coupon_code.split(",");
        // 去掉-1
        paramsCodes.forEach((item, index) => {
          if (item == "-1") {
            paramsCodes.splice(index, 1);
          }
        });
        this.params.coupon_code = paramsCodes.join();
        if (this.params.coupon_code.length > 0) {
          this.params.coupon_code += "," + this.inputCouponCode;
        } else {
          // 判断是否有默认使用的优惠券
          var status = this.userCoupons.some(function (item) {
            return item.checked == true;
          });
          if (status) {
            this.userCoupons.forEach((item) => {
              if (item.checked) {
                this.params.coupon_code =
                  this.inputCouponCode + "," + item.coupon_code;
              }
            });
          } else {
            this.params.coupon_code = this.inputCouponCode;
          }
        }
      }
    },
    // 移除/取消使用中的指定优惠券
    delCouponCode(code, current) {
      let arr = this.params.coupon_code.split(",");
      arr.splice(arr.indexOf(code), 1);
      current === 0 ? (this.optCoupon = "") : (this.inputCouponCode = "");
      this.params.coupon_code = arr.join();
    },
    // 移除优惠券码
    removeCouponCode(item) {
      console.log(item);
      // 移除params的优惠券码
      let arr = this.params.coupon_code.split(",");
      arr.splice(arr.indexOf(item.code), 1);
      this.params.coupon_code = arr.join();
      //移除inputCouArr列表中的的优惠券码
      let inputCouArr = [];
      this.inputCouArr.forEach((item1) => {
        if (item1.code != item.code) {
          inputCouArr.push(item1);
        }
      });
      this.inputCouArr = inputCouArr;
      // 如果都取消使用就不传coupon_code
      let paramsCodes = this.params.coupon_code.split(",");
      this.userCoupons.forEach((item) => {
        if (
          item.checked == false &&
          !this.inputCouArr.length &&
          (paramsCodes.length == 0 || JSON.stringify(paramsCodes) == '[""]')
        ) {
          this.params.coupon_code = "-1";
        }
      });
    },
    // 快递配送，门店自提切换
    changeTab(index) {
      this.tabCurrent = index;

      let receiptType = 1;
      if (this.tabCurrent != 1) {
        receiptType = 2;
      }
      this.receiptType = receiptType;

      this.getCartList();
    },
    // 获取默认店铺
    getDefaultStore() {
      if (this.storeSwitch == 1) {
        this.$api.defaultStore().then((res) => {
          if (res.status) {
            if (res.data && res.data.id) {
              let store = {
                id: res.data.id || 0,
                name: res.data.store_name || "",
                mobile: res.data.mobile || "",
                address: res.data.all_address || "",
              };
              this.store = store;
              console.log("store", this.store);
            } else {
              this.$common.errorToShow(this.$t("noDefaultStore"));
            }
          }
        });
      }
    },
    //获取门店列表
    getStoreList() {
      let data = {
        key: this.key,
      };
      this.$api.storeList(data).then((e) => {
        this.storeList = e.data;
        console.log("storeList", this.storeList);
      });
    },
    addStoreFunc() {
      this.key = "";
      this.getStoreList();
      this.dialogStoreVisible = true;
    },
    //门店搜索
    storeSearch() {
      this.getStoreList();
    },
    //门店选择
    selectStore(id, name, mobile, address) {
      this.store.id = id;
      this.store.name = name;
      this.store.mobile = mobile;
      this.store.address = address;
      this.dialogStoreVisible = false;
    },
  },
  created() {
    let cartIds = this.$route.query.cart_ids;
    this.params.ids = JSON.parse(cartIds);
    this.userDefaultShip();
    this.userShipList();

    this.getUserCounpons();
    //获取默认门店信息
    this.getDefaultStore();
    // 获取门店列表
    this.getStoreList();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";

.shop-container {
  padding: 0px 30px;
  box-sizing: border-box;
  margin: 20px auto;
}
.foot-bar {
  padding: 20px;
  text-align: right;
  margin: 0 -30px;
  border-top: 2px solid $border;
  .btn {
    display: inline-block;
    height: 40px;
    // line-height: 40px;
    color: #fff;
    background: $theme-color;
    width: 160px;
    text-align: center;
    cursor: pointer;
  }
}
.ct {
  color: $theme-color;
}
.order-box {
  &.foot {
    border: none;
    position: relative;
    min-height: 240px;
    .l {
      position: absolute;
      left: 0;
      right: 260px;
      top: 10px;
    }
    .r {
      position: absolute;
      right: 0px;
      bottom: 10px;
      .total-box {
        margin-bottom: 20px;
        .item {
          position: relative;
          padding-left: 100px;
          height: 26px;
          line-height: 26px;
          .title {
            position: absolute;
            left: 0;
            top: 0;
            display: inline-block;
            min-width: 120px;
            height: 28px;
            line-height: 28px;
            color: #757575;
            text-align: right;
          }
          .num {
            display: block;
            min-width: 180px;
            text-align: right;
            color: $theme-color;
            padding-left: 20px;
            &.total {
              font-size: 16px;
            }
          }
          &.total {
            margin-top: 10px;
            .total-num {
              font-size: 30px;
            }
          }
        }
      }
    }
  }
  border-bottom: 1px solid $border;
  padding-bottom: 20px;
  padding-top: 10px;
  .box-title {
    display: flex;
    align-items: center;
    h3 {
      height: 40px;
      line-height: 40px;
      font-weight: 550;
      margin-right: 60px;
    }
  }
  .box-info {
    padding: 20px 0px;
    display: flex;
    align-items: center;
    font-size: 14px;
    flex-flow: row wrap;
    &.invoice {
      span {
        padding: 0 8px;
        color: $theme-color;
        &.modify {
          cursor: pointer;
          &:hover {
            color: $theme-color;
          }
        }
      }
    }
    &.adress {
      .item {
        width: 270px;
        height: 180px;
        border: 1px solid $border;
        text-align: left;
        cursor: pointer;
        padding: 20px;
        box-sizing: border-box;
        position: relative;
        margin-left: 20px;
        margin-bottom: 20px;
        .default-icon {
          position: absolute;
          top: 0;
          right: 0;
          .icon {
            font-size: 48px;
            color: $theme-color;
          }
        }
        &.active {
          border-color: $theme-color;
          .change,
          .default {
            visibility: visible;
          }
        }
        .name {
          line-height: 30px;
          font-size: 24px;
          margin-bottom: 10px;
        }
        .tel,
        .address {
          line-height: 22px;
          color: #757575;
          margin-bottom: 5px;
        }
        .change {
          position: absolute;
          right: 14px;
          bottom: 20px;
          cursor: pointer;
          color: $theme-color;
          visibility: hidden;
        }
        .default {
          position: absolute;
          right: 100px;
          bottom: 20px;
          cursor: pointer;
          color: $theme-color;
          visibility: hidden;
        }
        &.add-adress {
          text-align: center;
          color: #999;
          transition: all 0.4s ease;
          &:hover {
            border-color: #333;
            color: #333;
            .icon {
              color: #333;
            }
          }
          .icon {
            display: block;
            width: 30px;
            height: 30px;
            margin: 43px auto 8px;
            font-size: 30px;
            line-height: 30px;
            border-radius: 17px;
            transition: all 0.4s ease;
            color: #e0e0e0;
          }
        }
      }
    }
    .pay-type {
      width: 130px;
      @include line-height(36px);
      text-align: center;
      border: 1px solid $border;
      margin-right: 30px;
      transition: all 0.2s;
      cursor: pointer;
      padding: 1px;
      box-sizing: border-box;
      &.active,
      &:hover {
        background: $theme-color;
        color: #fff;
        border: none;
      }
    }
  }
}
.cart-list-wrap {
  width: 100%;
  flex: 1;
  border: 1px solid $border;
}
.item-row {
  display: flex;
  align-items: center;
  border-top: 1px solid $border;
  &.item-head {
    border: none;
    height: 40px;
    .cart-total {
      color: #333;
    }
  }
  .cart-img {
    width: 80px;
    height: 80px;
    padding-right: 20px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .cart-name {
    flex: 1;
    margin-right: 20px;
    p {
      line-height: 1.4;
    }
    .tag {
      padding: 1px 10px;
      color: #fff;
      background: $theme-color;
      font-size: 12px;
      margin-right: 10px;
    }
  }
  .cart-info {
    width: 180px;
    color: #757575;
    font-size: 12px;
  }
  .cart-price {
    width: 100px;
    padding-right: 30px;
    text-align: right;
  }
  .cart-num {
    width: 150px;
    text-align: center;
  }
  .cart-total {
    width: 100px;
    padding-right: 30px;
    text-align: right;
    color: $theme-color;
  }
}
.conpon-tabs {
  height: 40px;
  padding-top: 10px;
  span {
    font-size: 14px;
    padding: 6px 0;
    margin-right: 30px;
    cursor: pointer;
    &.active {
      color: $theme-color;
      border-bottom: 2px solid $theme-color;
    }
  }
}
.coupon-wrap {
  width: 220px;
  margin: 0 20px 20px 0;
  transition: all 0.2s;
  cursor: pointer;
  position: relative;
  &.checked {
    background: #fff;
    color: $theme-color;
    outline: 2px solid red;
    .content {
      background: none;
    }
    .icon {
      position: absolute;
      bottom: -3px;
      right: -3px;
      font-size: 24px;
      color: red;
    }
  }
  &.disabled {
    background: #d1d1d1;
    cursor: no-drop;
    .content {
      background: none;
    }
  }
}
.tab-content {
  .exchange {
    span {
      font-size: 12px;
    }
    input {
      border: 1px solid $border;
      width: 150px;
      height: 20px;
      line-height: 20px;
      margin: 0 10px;
    }
    a {
      display: inline-block;
      height: 22px;
      line-height: 22px;
      padding: 0 15px;
      background: $theme-color;
      color: #fff;
    }
  }
}
.tabs {
  .tab {
    display: inline-block;
    cursor: pointer;
  }
  .tab-active {
    color: #ff7159;
    border-bottom: 2px solid #ff7159;
  }
}

.store-form {
  width: 600px;
  margin: 0 auto;
  padding: 30px 10px;
  .store-list {
    margin-top: 20px;
    display: flex;
    justify-content: flex-start;
    border-bottom: 1px solid rgb(204 204 204 / 0.2);
    cursor: pointer;
    .store-l {
      display: flex;
      align-items: center;
      .store-icon {
        width: 25px;
        height: 25px;
        margin-right: 20px;
      }
    }

    .store-item {
      .item {
        margin-bottom: 10px;
      }
      .store-mobile {
        color: #999;
      }
    }
  }
  .store-list:last-child {
    border: none;
  }
}
.search {
  width: 100%;
  height: 50px;
  background: white;
  border: 1px solid gainsboro;
  padding: 10px 0 10px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.2s;
  position: relative;
  box-sizing: border-box;
}
.search .search-input {
  display: block;
  flex: 1;
  height: 20px;
}
.search .search-icon-wrap {
  display: inline-block;
  width: 50px;
  height: 50px;
  position: relative;
  border-left: 1px solid gainsboro;
  transition: all 0.2s;
  cursor: pointer;
}
.search-icon {
  position: absolute;
  width: 20px;
  height: 20px;
  top: 15px;
  left: 15px;
}
.search-icon .el-icon-search {
  font-size: 20px;
}
.nodata {
  margin-top: 20px;
}
.search-name {
  color: #ff7159;
}
.delivery-item {
  margin-left: 20px;
  display: inline-block;
  width: 270px;
  height: 35px;
  line-height: 35px;
  margin-top: 20px;
  input {
    border-bottom: 1px solid #ccc;
    width: 82%;
    height: 100%;
  }
}

.def-img{
  width: 50px;
}
</style>
<style>
.store .el-dialog {
  width: 660px !important;
  min-height: 400px;
}
</style>
